import { useEffect, useCallback } from 'react';

const REMINDER_KEY = 'kariyer_daily_reminder';
const NOTIFICATION_PERMISSION_KEY = 'kariyer_notification_permission';

export const useDailyReminder = (user, stats) => {
  
  // Bildirim izni iste
  const requestNotificationPermission = useCallback(async () => {
    if (!('Notification' in window)) {
      console.log('Bu tarayıcı bildirimleri desteklemiyor');
      return false;
    }
    
    if (Notification.permission === 'granted') {
      localStorage.setItem(NOTIFICATION_PERMISSION_KEY, 'granted');
      return true;
    }
    
    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      localStorage.setItem(NOTIFICATION_PERMISSION_KEY, permission);
      return permission === 'granted';
    }
    
    return false;
  }, []);

  // Bildirim gönder
  const sendNotification = useCallback((title, body, icon = '✈️') => {
    if (Notification.permission === 'granted') {
      const notification = new Notification(title, {
        body,
        icon: '/logo192.png',
        badge: '/logo192.png',
        tag: 'daily-reminder',
        requireInteraction: true
      });
      
      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    }
  }, []);

  // Günlük hatırlatıcı kontrolü
  const checkDailyReminder = useCallback(() => {
    if (!user || !stats) return;
    
    const today = new Date().toDateString();
    const lastReminder = localStorage.getItem(REMINDER_KEY);
    
    // Bugün zaten hatırlatma yapıldı mı?
    if (lastReminder === today) return;
    
    // Günlük 10 dakika hedefi tamamlandı mı?
    const todayMinutes = stats?.today_minutes || 0;
    
    if (todayMinutes < 10) {
      // Saat kontrolü - sabah 10, öğlen 14, akşam 19'da hatırlatma
      const now = new Date();
      const hour = now.getHours();
      
      // Belirli saatlerde hatırlatma
      if (hour === 10 || hour === 14 || hour === 19) {
        const remainingMinutes = 10 - todayMinutes;
        sendNotification(
          '✈️ Kariyer Online Hatırlatma',
          `Bugün ${todayMinutes} dakika çalıştın. Hedefine ulaşmak için ${remainingMinutes} dakika daha çalış!`
        );
        localStorage.setItem(REMINDER_KEY, today);
      }
    } else {
      // Hedef tamamlandı
      localStorage.setItem(REMINDER_KEY, today);
    }
  }, [user, stats, sendNotification]);

  // Streak kaybı uyarısı
  const checkStreakWarning = useCallback(() => {
    if (!user || !stats) return;
    
    const todayMinutes = stats?.today_minutes || 0;
    const streak = stats?.streak || 0;
    
    // Streak 3'ten büyükse ve bugün henüz çalışmadıysa
    if (streak >= 3 && todayMinutes === 0) {
      const now = new Date();
      const hour = now.getHours();
      
      // Akşam 20'de streak uyarısı
      if (hour >= 20) {
        sendNotification(
          '🔥 Streak Uyarısı!',
          `${streak} günlük serinizi kaybetmek üzeresiniz! Hemen 10 dakika çalışın.`
        );
      }
    }
  }, [user, stats, sendNotification]);

  // Başlatma
  useEffect(() => {
    if (user) {
      requestNotificationPermission();
    }
  }, [user, requestNotificationPermission]);

  // Periyodik kontrol
  useEffect(() => {
    if (!user || !stats) return;
    
    // İlk kontrol
    checkDailyReminder();
    checkStreakWarning();
    
    // Her 30 dakikada bir kontrol
    const interval = setInterval(() => {
      checkDailyReminder();
      checkStreakWarning();
    }, 30 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, [user, stats, checkDailyReminder, checkStreakWarning]);

  return {
    requestNotificationPermission,
    sendNotification
  };
};

export default useDailyReminder;
